import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import {
    Box,
    Button,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import RevokeAlert from './RevokeAlert';
import FlipperClock from './FlipperClock';

// third party
import moment from 'moment';
import { Stack } from '@mui/system';

const BoardDetails = ({ venueUuid }) => {

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);

    const getBoardListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
    };

    const handleViewBoard = (boardUuid) => {
        navigate(`/board/view/${boardUuid}`);
    };

    const getBoardListApi = useApi(VenueService.getBoardList, getBoardListHandler);

    useEffect(() => {
        getBoardListApi.execute({
            uuid_venue: venueUuid,
            limit: 20,
            skip: 0
        });
    }, [reload]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ pl: 3 }}>#</TableCell>
                                <TableCell>Board Id</TableCell>
                                <TableCell>Turf Name</TableCell>
                                <TableCell>Board Name</TableCell>
                                <TableCell>Last Active Time</TableCell>
                                <TableCell align='center'>Timer</TableCell>
                                <TableCell align='center'>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((row, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                        <Typography align="left" variant="subtitle1" component="div">
                                            <Link
                                                underline='always'
                                                onClick={() => handleViewBoard(row.uuid)}
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                {row.board_id}
                                            </Link>
                                        </Typography>
                                        <TableCell>{row.turf_name}</TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>
                                            {row.last_active_time ? (
                                                <Grid container spacing={2}>
                                                    <Grid item xs zeroMinWidth>
                                                        <Typography align="left" variant="subtitle1" component="div">
                                                            {moment(row.last_active_time.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                                        </Typography>
                                                        <Typography align="left" variant="subtitle2" noWrap>
                                                            {moment(row.last_active_time.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            ) : (<>-</>)}
                                        </TableCell>
                                        <TableCell>{
                                            row.revoke ? (
                                                <FlipperClock boardEndTime={row.boardEndTime} />
                                            ) : ''
                                        }
                                        </TableCell>
                                        <TableCell align='center' sx={{ pr: 3 }}>
                                            {row.revoke ?
                                                (<Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="center">
                                                    <Button>
                                                        <RevokeAlert setReload={setReload} boardUuid={row.uuid} bookingUuid={row.booking_uuid} />
                                                    </Button>
                                                </Stack>) : ''

                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </MainCard>
        </Box>
    );
};

export default BoardDetails;
